import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

type FaqItem = { q: string; a: string };

const faqGeneral: FaqItem[] = [
  {
    q: 'Wie läuft ein typisches Automatisierungsprojekt bei gowiTEC ab?',
    a: 'Nach Ihrer Anfrage analysieren wir gemeinsam Ihre Anforderungen und erstellen ein unverbindliches Angebot. Anschließend folgen Konzeption, Konstruktion, Programmierung, Fertigung und Inbetriebnahme – alles aus einer Hand. Wir begleiten Sie von der ersten Idee bis zur laufenden Anlage und stehen auch danach als Ansprechpartner zur Verfügung.',
  },
  {
    q: 'Bietet gowiTEC auch Wartung und Service nach der Inbetriebnahme an?',
    a: 'Ja, wir bieten langfristige Wartungsverträge, Fernwartung und schnellen Vor-Ort-Service. Unsere Reaktionszeit beträgt in der Regel unter 24 Stunden. Auf Wunsch schulen wir auch Ihr Bedienpersonal direkt an der Anlage.',
  },
  {
    q: 'Für welche Unternehmensgrößen arbeitet gowiTEC?',
    a: 'Wir arbeiten sowohl für mittelständische Unternehmen als auch für größere Industriebetriebe – überall dort, wo individuelle Automatisierungslösungen gefragt sind. Unsere Projekte reichen von Einzelmaschinen bis hin zu kompletten Fertigungslinien.',
  },
  {
    q: 'Wie kann ich ein Projekt anfragen?',
    a: 'Ganz einfach über unser Online-Formular, per E-Mail an anfrage@gowitec.de oder telefonisch unter +49 1776512122. Wir melden uns innerhalb von 24 Stunden – kostenlos und unverbindlich.',
  },
];

const faqOmron: FaqItem[] = [
  {
    q: 'Was ist der Unterschied zwischen OMRON NJ und NX?',
    a: 'Die NJ-Serie ist ein leistungsstarker Machine Controller, der SPS und Motion Control auf einer Plattform vereint – ideal für Mehrachsanwendungen und Montageautomation. Die NX-Serie ist modular aufgebaut und bietet skalierbare I/O-Systeme sowie integrierte Safety-Funktionen (NX Safety CPU). Beide Serien werden in Sysmac Studio programmiert.',
  },
  {
    q: 'Was ist Sysmac Studio und warum wird es verwendet?',
    a: 'Sysmac Studio ist die einheitliche Engineering-Software von OMRON für SPS, Motion Control, HMI und Safety. Alle Projektdaten werden in einer einzigen Umgebung verwaltet – das spart Zeit, reduziert Fehler und ermöglicht eine strukturierte Programmierung nach IEC 61131-3 (Structured Text, Function Blocks, Ladder).',
  },
  {
    q: 'Welche Kommunikationsprotokolle unterstützen OMRON-Systeme?',
    a: 'OMRON Sysmac-Systeme unterstützen EtherCAT für Echtzeit-Motion-Control, EtherNet/IP für die Anlagenvernetzung sowie OPC-UA für die Anbindung an übergeordnete MES- und SCADA-Systeme. Auch Profinet und Modbus TCP sind über entsprechende Module integrierbar.',
  },
  {
    q: 'Kann gowiTEC bestehende OMRON-Anlagen erweitern oder modernisieren?',
    a: 'Ja, wir analysieren bestehende OMRON-Installationen, erweitern sie um neue Funktionen oder migrieren ältere Steuerungen auf aktuelle Sysmac-Hardware. Dabei achten wir auf maximale Kompatibilität und minimale Produktionsunterbrechung.',
  },
  {
    q: 'Wie wird die Sicherheitstechnik bei OMRON-Anlagen umgesetzt?',
    a: 'Sicherheitsfunktionen werden direkt in der OMRON NX Safety CPU programmiert – nach EN ISO 13849 (PLd/PLe) und IEC 62061 (SIL 2/SIL 3). Wir erstellen die vollständige Sicherheitsdokumentation inklusive Risikobeurteilung und Validierungsprotokoll.',
  },
  {
    q: 'Wie lange dauert eine typische OMRON-Inbetriebnahme?',
    a: 'Das hängt von der Komplexität der Anlage ab. Einfache Steuerungsaufgaben können in wenigen Tagen in Betrieb genommen werden, komplexe Mehrachssysteme mit Safety-Integration benötigen in der Regel mehrere Wochen. Wir geben Ihnen nach der Anfrage eine realistische Zeitplanung.',
  },
];

const faqLoxone: FaqItem[] = [
  {
    q: 'Was ist der Loxone Miniserver und was kann er?',
    a: 'Der Loxone Miniserver ist die zentrale Steuereinheit der Loxone-Gebäudeautomation. Er vernetzt Beleuchtung, Beschattung, Heizung, Lüftung, Sicherheitstechnik und Energie in einem einzigen System. Die Steuerung erfolgt über die Loxone App (iOS/Android) oder per Webinterface – auch aus der Ferne.',
  },
  {
    q: 'Für welche Gebäudetypen eignet sich Loxone?',
    a: 'Loxone ist ideal für Gewerbegebäude, Industriehallen, Büros und Produktionsstätten. Überall dort, wo Energieeffizienz, Komfort und Sicherheit eine Rolle spielen, lohnt sich der Einsatz. Wir realisieren Loxone-Projekte ab Neubau bis hin zur Nachrüstung in Bestandsgebäuden.',
  },
  {
    q: 'Kann Loxone in bestehende Gebäudetechnik integriert werden?',
    a: 'Ja, Loxone unterstützt eine Vielzahl von Protokollen wie KNX, Modbus, MQTT und HTTP. Damit lässt sich Loxone nahtlos in bestehende Gebäudeinfrastrukturen integrieren – ohne alles neu verkabeln zu müssen. Wir analysieren Ihre Bestandsanlage und planen die optimale Integrationsstrategie.',
  },
  {
    q: 'Wie sicher ist die Loxone-Steuerung gegen Ausfälle?',
    a: 'Der Loxone Miniserver arbeitet lokal – ohne Abhängigkeit von Cloud-Diensten. Alle Automatisierungsfunktionen laufen direkt auf dem Gerät. Bei Netzwerkausfall funktionieren alle programmierten Abläufe weiterhin. Zusätzlich können Backup-Systeme und USV-Versorgung integriert werden.',
  },
  {
    q: 'Kann Loxone auch PV-Anlagen und Wallboxen steuern?',
    a: 'Ja, Loxone integriert Photovoltaikanlagen, Batteriespeicher und Wallboxen intelligent. Der Eigenverbrauch wird maximiert, Ladezeiten werden automatisch auf günstige Stromtarife und Sonnenstunden optimiert. Das spart Energiekosten und schont die Umwelt.',
  },
  {
    q: 'Wie wird die Loxone-Anlage programmiert und wer übernimmt das?',
    a: 'Die Programmierung erfolgt mit Loxone Config – der grafischen Engineering-Software. Wir übernehmen die komplette Planung, Programmierung und Inbetriebnahme. Nach Abschluss erhalten Sie eine vollständige Dokumentation und eine Einweisung in die Bedienung über die Loxone App.',
  },
];

const tabs = [
  { id: 'general', label: 'Allgemein', faqs: faqGeneral },
  { id: 'omron', label: 'OMRON', faqs: faqOmron },
  { id: 'loxone', label: 'Loxone', faqs: faqLoxone },
];

const allFaqs = [...faqGeneral, ...faqOmron, ...faqLoxone];

const SCHEMA_JSON = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: allFaqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
});

const LeistungenFaq = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [open, setOpen] = useState<number | null>(0);

  const currentFaqs = tabs.find((t) => t.id === activeTab)?.faqs ?? [];

  useEffect(() => {
    setOpen(0);
  }, [activeTab]);

  useEffect(() => {
    const id = 'schema-leistungen-faq';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = SCHEMA_JSON;
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, []);

  return (
    <section className="py-24 bg-[#F8FAFC] border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4 leading-tight">
            Häufig gestellte Fragen
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Antworten zu unseren Leistungen, OMRON Sysmac und Loxone Gebäudeautomation –
            direkt und ohne Umwege.
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex bg-white border border-gray-200 rounded-full p-1 gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'bg-[#1E3A8A] text-white'
                    : 'text-gray-500 hover:text-gray-800'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Accordion + Sidebar */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">

          {/* Sidebar */}
          <div className="lg:col-span-2 bg-white rounded-xl border border-gray-100 p-8 flex flex-col gap-6">
            {activeTab === 'general' && (
              <>
                <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl">
                  <i className="ri-question-answer-line text-[#1E3A8A] text-xl"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-bold text-lg mb-2">Allgemeine Fragen</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    Alles rund um Projektablauf, Service, Wartung und die Zusammenarbeit mit gowiTEC.
                  </p>
                </div>
              </>
            )}
            {activeTab === 'omron' && (
              <>
                <div className="w-full h-12 flex items-center justify-start">
                  <img
                    src="https://www.omron.com/content/dam/omron/omroncms/global/images/logo/omron-logo.svg"
                    alt="OMRON Logo"
                    className="h-8 object-contain"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-gray-900 font-bold text-lg mb-2">OMRON Sysmac</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    Fragen zu NJ/NX-Steuerungen, Sysmac Studio, EtherCAT, Safety und Inbetriebnahme.
                  </p>
                </div>
                <div className="flex flex-wrap gap-2">
                  {['NJ / NX', 'Sysmac Studio', 'EtherCAT', 'Safety CPU'].map((tag) => (
                    <span key={tag} className="bg-[#EFF6FF] text-[#1E3A8A] text-xs font-medium px-2.5 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </>
            )}
            {activeTab === 'loxone' && (
              <>
                <div className="w-full h-12 flex items-center justify-start">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Loxone_Logo.svg/320px-Loxone_Logo.svg.png"
                    alt="Loxone Logo"
                    className="h-8 object-contain"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-gray-900 font-bold text-lg mb-2">Loxone Gebäudeautomation</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    Fragen zu Miniserver, App-Steuerung, KNX-Integration, PV und Sicherheitstechnik.
                  </p>
                </div>
                <div className="flex flex-wrap gap-2">
                  {['Miniserver', 'KNX', 'MQTT', 'PV & Wallbox'].map((tag) => (
                    <span key={tag} className="bg-[#F0F9E8] text-[#4a8a20] text-xs font-medium px-2.5 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </>
            )}

            <div className="mt-auto pt-4 border-t border-gray-100">
              <p className="text-gray-400 text-xs mb-3">Noch Fragen offen?</p>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 border border-gray-200 hover:border-[#1E3A8A] text-gray-700 hover:text-[#1E3A8A] font-semibold px-5 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-sm w-full justify-center"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-send-line"></i>
                </span>
                Direkt anfragen
              </Link>
            </div>
          </div>

          {/* Accordion */}
          <div className="lg:col-span-3 flex flex-col divide-y divide-gray-100 bg-white rounded-xl border border-gray-100 px-6" role="list">
            {currentFaqs.map((faq, i) => (
              <div key={`${activeTab}-${i}`} className="py-5" role="listitem">
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-start justify-between gap-4 text-left cursor-pointer group"
                  aria-expanded={open === i}
                >
                  <h4 className="text-gray-900 font-semibold text-base leading-snug group-hover:text-[#1E3A8A] transition-colors">
                    {faq.q}
                  </h4>
                  <span
                    className={`w-6 h-6 flex items-center justify-center shrink-0 mt-0.5 rounded-full border transition-all duration-200 ${
                      open === i
                        ? 'bg-[#1E3A8A] border-[#1E3A8A] text-white'
                        : 'border-gray-200 text-gray-400 group-hover:border-[#1E3A8A] group-hover:text-[#1E3A8A]'
                    }`}
                    aria-hidden="true"
                  >
                    <i className={`ri-${open === i ? 'subtract' : 'add'}-line text-sm`}></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${open === i ? 'max-h-96 mt-3' : 'max-h-0'}`}
                >
                  <p className="text-gray-500 text-sm leading-relaxed pr-10">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default LeistungenFaq;
